import React from "react";
import "./HowWeWork.css";

const howWeWork = () => {
  return (
    <div className="df hww_wrpr" id="process">
      <p className="hdr bf">How we work</p>

      <div className="img_wrpr" />
    </div>
  );
};

export default howWeWork;



// WEBPACK FOOTER //
// ./src/components/how-we-work/HowWeWork.js